import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OperacaoFinanceiraDetalharComponent } from './operacao-financeira-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: OperacaoFinanceiraDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class OperacaoFinanceiraDetalharRoutingModule { }
